class CloseFilters {
    constructor(args = { sectionsContainer: document }) {
        this.sectionsContainer = args.sectionsContainer;
        this.sections = this.sectionsContainer.getElementsByClassName("container-filters");
        if (this.sections[0]) {
            this.init();
        }
    }

    init() {
        Array.from(this.sections).forEach((section) =>
            this.initDesplegables(section)
        );
    }

    initDesplegables(section) {
        const closeFilters = section.querySelector('.btn-close');
        const menuFilters = section.querySelector('.filters-wrap');
        //console.log(closeFilters)
        //console.log(menuFilters)
        
        if (closeFilters) {
            closeFilters.addEventListener('click', () => {
                //console.log(menuFilters.classList)
                if (menuFilters.classList.contains('open')) {
                    menuFilters.classList.remove('open');
                    document.body.classList.remove('no-scroll');
                }
            });
        }
    }
}

export default CloseFilters;
